import { useEffect, useRef } from 'react'

export const useDynamicTitle = (title: string, opts?: { keepOnUnMount: boolean }) => {
    const keepOnUnMount = opts?.keepOnUnMount
    const priorTitle = useRef(document.title)

    useEffect(() => {
        document.title = title
    }, [title])

    useEffect(
        () => () => {
            if (keepOnUnMount && priorTitle.current) {
                document.title = priorTitle.current
            }
        },
        [keepOnUnMount],
    )
}
